<template>
  <div class="conrainer">
      <BigScreenHead/>
      <main>
           <div class="center-tab">
                <div class="tab-title tabcolor" @click="clickChanPing">产品版图</div>
                <p></p>
                <div class="tab-title" @click="clickKeHu" >客户分布</div>
                <p></p>
                <div class="tab-title" @click="clickWangDian" >服务网点</div>
                <div class="search">
                    <input type="text" v-model="searchValue" :placeholder="'根据'+(count==1?'IMEI':count==2?'客户名称':'网点名称')+'搜索'">
                </div>
            </div>
          <div class="main-left">
              <div class="clicktitle" @click="$router.push('/ProductionBigScreen')">
                  <img src="../assets/images/shou.gif" style="width:32px;height:33px">
                  <span>生 产</span>
              </div>
              <ul class="main-left-ul">
                  <li></li>
                  <li>
                      <img src="../assets/images/tower.webp" style="margin-right:7px">
                      塔机
                  </li>
                  <li>
                      <img src="../assets/images/lifter.webp" style="margin-right:7px">
                      升降机
                  </li>
                  <li>
                      <p>设备</p>
                      <p>产量</p>
                  </li>
                  <li>{{productionInfo.towerTotal}}</li>
                  <li>{{productionInfo.lifterTotal}}</li>
              </ul>
              <div class="left-pei">
                  <div class="left-pei0">
                      <p>联网</p>
                      <p>状态</p>
                  </div>
                  <div class="left-pei1"></div>
                  <div class="left-pei2"></div>
              </div>
               <div class="clicktitle" style="margin-top:7px" @click="$router.push('/SaleBigScreen')">
                  <img src="../assets/images/shou.gif" style="width:32px;height:33px">
                  <span>销 售</span>
              </div>
              <div class="left-circle">
                  <div class="left-circle0">客户
                     <div class="left-circle1">总数（家）
                         <p>{{saleInfo.customerTotal}}</p>
                     </div>
                     <div class="left-circle2">本月新增（家）
                         <p>{{saleInfo.customerMon}}</p>
                     </div>
                  </div>
              </div>
              <div class="charttitle">近一年销售统计</div>
              <div class="left-chart-line"></div>
          </div>
          <div class="main-center">
             
          </div>
          <div class="main-right">
              <div style="display: flex;justify-content: flex-end">
                  <div class="clicktitle" @click="$router.push('/CollectionBigScreen')">
                    <span>收 款</span>
                    <img src="../assets/images/shou.gif" style="width:32px;height:33px">
                </div>
              </div>
              <div class="right-sixcircle">
                  <div class="right-sixcircle0">
                      塔机
                      <div class="right-sixcircle1">
                          按揭中
                          <p>{{collectionInfo.towerMortgage}}</p>
                      </div>
                      <div class="right-sixcircle2">
                          本月已还款
                          <p>{{collectionInfo.towerMRepayment}}</p>
                      </div>
                      <div class="right-sixcircle3">
                          按揭中
                          <p>{{collectionInfo.lifterMortgage}}</p>
                      </div>
                      <div class="right-sixcircle4">
                          本月已还款
                          <p>{{collectionInfo.lifterMRepayment}}</p>
                      </div>
                      <div class="right-sixcircle5">
                          升降机
                      </div>
                  </div>
              </div>
              <div class="chaoqi">
                  <div class="chaoqi1"></div>
                  <div class="chaoqi2"></div>
                  <div class="chaoqi3">
                      <p>超期</p>
                      <p>还款</p>
                  </div>
              </div>
               <div style="display: flex;justify-content: flex-end;margin-top:5px">
                  <div class="clicktitle" @click="$router.push('/ServiceBigScreen')">
                    <span>服 务</span>
                    <img src="../assets/images/shou.gif" style="width:32px;height:33px">
                </div>
              </div>
              <div class="right-fuwu">
                  <div class="right-fuwu-item">
                      网点
                      <p>{{serviceInfo.nodeTotal}}</p>
                  </div>
                  <div class="right-fuwu-item">
                      人员
                      <p>{{serviceInfo.personTotal}}</p>
                  </div>
                  <div class="right-fuwu-item">
                      报修中
                      <p style="color:#BF0000">{{serviceInfo.repairCount}}</p>
                  </div>
              </div>
              <div class="baoxiu">
                  近30天报修曲线
              </div>
              <div class="baoxiuline"></div>
          </div>
      </main>
      <footer>
          <div class="ft-left">
              <div class="ft-title" @click="toAbnomal" style="cursor:pointer">
                  <img src="../assets/images/shou.gif" style="width:32px;height:33px">
                  <p>今</p>
                  <p>日</p>
                  <p>异</p>
                  <p>常</p>
              </div>
              <div class="yichang1">
              </div>
              <div class="yichang2">
              </div>
          </div>
          <div class="ft-right">
              <div class="ft-title" style="margin:0 20px">
                  <p>关</p>
                  <p>注</p>
                  <p>设</p>
                  <p>备</p>
              </div>
               <div class="swiper-father">
                <div class="swiper-container">
                    <div class="swiper-wrapper" @click="swiperClick">
                    <div
                        class="swiper-slide"
                        v-for="(item, i) in guanzhuData"
                        :key="i"
                    >
                        <div class="swiper-top">
                            <i class="iconfont">{{item.type==1?'&#xe612;':'&#xe613;'}}</i>
                            <p :style="{fontWeight:'bold', color:item.onlineState==1?'#40b337':(item.onlineState==0?'#edb941':'#7194F3')}">{{item.onlineState==1?'在线':(item.onlineState==0?'未通电':'信号差')}}</p>
                        </div>
                        <div class="swiper-item">
                            <p>·出厂编号：{{item.factorNo}}</p>
                            <p>·客户名称：{{item.customerName}}</p>
                            <p>·销售公司：{{item.salesCompanyName}}</p>
                            <p v-if="item.type==1">
                                ·监控主机：<span :data-item="JSON.stringify(item)" class="click-span">{{item.imei}}</span>
                            </p>
                            <p v-if="item.type==2" >
                                ·左笼监控：<span :data-item="JSON.stringify(item)" :data-cagecate="1" class="click-span">{{item.imei}}</span>
                            </p>
                            <p v-if="item.type==2">
                                ·右笼监控：<span :data-item="JSON.stringify(item)" :data-cagecate="2" class="click-span">{{item.rightImei}}</span>
                            </p>
                        </div>
                    </div>
                    </div>
                </div>
                <div class="swiper-button-prev"></div>
                <div class="swiper-button-next"></div>
            </div>
          </div>
      </footer>
  </div>
</template>

<script>
import Swiper from "swiper";
import "swiper/css/swiper.min.css";
import { homeChinaMap,onlineStatusChart,homeXiaoShou,homeChaoQi,homeBaoXiu,homeYibiao } from '../assets/js/echarts'


export default {
    data(){
        return{
            serviceInfo:{},
            productionInfo:{},
            collectionInfo:{},
            saleInfo:{},
            chanpingData: [],
            kehuData: [],
            nodeData: [],
            guanzhuData: [],
            alarm: '',
            violation: '',
            addressObj:{},
            addressArr:[],
            root:[],
            count: 1,
            timer:null,
            isFirst: true,
            searchValue: '',
        }
    },
    methods:{
        //点击轮播图
        swiperClick(e) {
            if(e.target.nodeName == 'SPAN'){
                var item = JSON.parse(e.target.dataset.item)
                if(item.type == 1){
                    this.$router.push('/TowerBigScreen?imei='+item.imei)
                }else{
                    var cagecate = e.target.dataset.cagecate;
                    this.$router.push('/LifterBigScreen?imei='+item.imei+'&cagecate='+cagecate)
                }
            }
        },
        //地图的切换
        clickChanPing(){
            var doc = document.querySelectorAll('.tab-title');
            doc[0].classList.add('tabcolor');
            doc[1].classList.remove('tabcolor');
            doc[2].classList.remove('tabcolor');
            homeChinaMap({
                data: this.chanpingData,
                type: 1,
                addressObj:this.addressObj,
                addressArr:this.addressArr,
                _this: this,
                root:this.root,
            });
            if(!this.isFirst){
                this.count = 1;
            }
            this.isFirst = false
        },
        clickKeHu(){
            var doc = document.querySelectorAll('.tab-title');
            doc[1].classList.add('tabcolor');
            doc[0].classList.remove('tabcolor');
            doc[2].classList.remove('tabcolor');
            homeChinaMap({
                data: this.kehuData,
                type: 2
            });
            this.count = 2
        },
        clickWangDian(){
            var doc = document.querySelectorAll('.tab-title');
            doc[2].classList.add('tabcolor');
            doc[1].classList.remove('tabcolor');
            doc[0].classList.remove('tabcolor');
            homeChinaMap({
                data: this.nodeData,
                type: 3
            });
            this.count = 3
        },
        //动态地图切换
        activeMap(){
            if(this.timer) clearInterval(this.timer);
            this.timer = setInterval(() => {
                this.count += 1;
                if(this.count > 3) this.count = 1;
                if(this.count==1){
                    this.clickChanPing()
                }
                if(this.count==2){
                    this.clickKeHu()
                }
                if(this.count==3){
                    this.clickWangDian()
                }
            }, 1000*60);
        },
        //地图重置
        reset(){
            this.searchValue = ''
        },
        //swiper轮播
        swiperInit(flag){
            this.$nextTick(()=>{
                var mySwiper = new Swiper(".swiper-container", {
                    slidesPerView: 4,
                    loopedSlides: 4,
                    speed: 1200, //滑动速度
                    loop: flag,
                    spaceBetween: 0, //每个元素的间距
                    grabCursor: true, //出现手型
                    autoplay: {
                        delay: 3000,
                        disableOnInteraction: false, //鼠标操作后不会停止
                    },
                    navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                    },
                });
                mySwiper.el.onmouseover = function () {
                    mySwiper.autoplay.stop();
                };
                mySwiper.el.onmouseleave = function () {
                    mySwiper.autoplay.start();
                };
            })
        },
        //生产情况信息
        getProductionInfo(){
            this.$api.ProductionInfo().then(res=>{
                this.productionInfo = res.data.data;
                var towerOnline = res.data.data.towerOnlinePercentage;
                var lifterOnline = res.data.data.lifterOnlinePercentage;
                onlineStatusChart({doc: '.left-pei1',type: 1,data: towerOnline});
                onlineStatusChart({doc: '.left-pei2',type: 2,data: lifterOnline});
            })
        },
        //销售情况信息
        getSaleInfo(){
            this.$api.SaleInfo().then(res=>{
                this.saleInfo = res.data.data;
                var date = [];
                this.saleInfo.saleDate.map((item,i)=>{
                    if(item.slice(5,6)==0){
                        date[i] = item.slice(6,7)
                    }else{
                        date[i] = item.slice(5,7)
                    }
                })
                homeXiaoShou({
                    doc:'.left-chart-line',
                    date,
                    saleLifter:this.saleInfo.saleLifter,
                    saleTower:this.saleInfo.saleTower,
                });
            })
        },
        //收款情况信息
        getCollectionInfo(){
            this.$api.CollectionInfo().then(res=>{
                this.collectionInfo = res.data.data;
                homeChaoQi({doc: '.chaoqi1',type:1,data:this.collectionInfo.overdueDevice});
                homeChaoQi({doc: '.chaoqi2',type:2,data:this.collectionInfo.overdueCustomer});
            })
        },
        //服务情况信息
        getServiceInfo(){
            this.$api.ServiceInfo().then(res=>{
                this.serviceInfo = res.data.data;
                var date = [];
                this.serviceInfo.repairDate.map((item,i)=>{
                    if(item.slice(3,4)==0){
                        date[i] = item.slice(4,5)
                    }else{
                        date[i] = item.slice(3,5)
                    }
                })
                homeBaoXiu({doc: '.baoxiuline',date,data:this.serviceInfo.repairRecord});
            })
        },
        //告警情况信息
        getAbnormalInfo(){
            this.$api.AbnormalInfo().then(res=>{
                this.alarm = res.data.data.alarm;
                this.violation = res.data.data.violation;
                homeYibiao({doc:'.yichang1',text:'告 警',data:this.alarm,color:'#bf0000'})
                homeYibiao({doc:'.yichang2',text:'违 章',data:this.violation,color:'#EDB941'})
            })
        },
        //关注设备
        getAttentionDeviceInfo(){
            this.$api.AttentionDeviceInfo().then(res=>{
                var flag = false;
                this.guanzhuData = res.data.data
                if(this.guanzhuData.length > 4){
                    flag = true;
                }else{
                    flag = false;
                }
                this.swiperInit(flag);
            })
        },
        //产品版图
        getDeviceAddressInfo(){
            this.$api.DeviceAddressInfo().then(res=>{
                var arr1 = [];
                var arr2 = [];
                this.root[0] = res.data.data.gpsX;
                this.root[1] = res.data.data.gpsY;
                res.data.data.data.map((item,i)=>{
                    var addressName = item.sendAddress || '暂无地址'
                    arr1.push({ [addressName]:[item.gpsX, item.gpsY] });
                    arr2.push([{ name: addressName,value:0 }]);
                    this.chanpingData[i] = {
                        name: item.sendAddress,
                        value: [item.gpsX, item.gpsY],
                        type: item.type,
                        factorNo:item.factorNo,
                        modelName:item.modelName,
                        customerName:item.customerName,
                        sendAddress:item.sendAddress,
                        imei:item.imei,
                        rightImei:item.rightImei,
                        addressList1:{
                            [addressName]: [item.gpsX, item.gpsY],
                        },
                        addressList2:[[{
                            name: item.sendAddress,
                            value:0
                        }]]
                    }
                });
                var addressObj = {}
                arr1.map((item,i)=>{
                    addressObj[Object.keys(item)[0]] = item[Object.keys(item)[0]]
                })
                this.addressObj = addressObj;
                this.addressArr = arr2;
                this.clickChanPing();
                this.activeMap();
                var doc = document.querySelector('.search input');
                
                //地图的模糊查询
                doc.addEventListener('keydown',(e)=>{
                    if(e.keyCode==13){
                        if(this.count == 1){
                            var temeData = this.chanpingData.filter(item=>{
                                return (item.imei.indexOf(this.searchValue) >= 0) || (item.rightImei && item.rightImei.indexOf(this.searchValue) >=0)
                            })
                            homeChinaMap({
                                data: temeData,
                                type: 1,
                                addressObj:this.addressObj,
                                addressArr:this.addressArr,
                                _this: this,
                                root:this.root,
                            });
                        }
                        if(this.count == 2){
                            var temeData = this.kehuData.filter(item=>{
                                return item.name.indexOf(this.searchValue) >=0
                            })
                            homeChinaMap({
                                data: temeData,
                                type: 2
                            });
                        }
                        if(this.count == 3){
                            var temeData = this.nodeData.filter(item=>{
                                return item.name.indexOf(this.searchValue) >=0
                            })
                            homeChinaMap({
                                data: temeData,
                                type: 3
                            });
                        }
                    }
                })
            })
        },
        //客户版图
        getCustomerAddressInfo(){
            this.$api.CustomerAddressInfo().then(res=>{
                res.data.data.map((item,i)=>{
                    this.kehuData[i] = {
                        name: item.name,
                        value: [item.gpsX, item.gpsY],
                        linker: item.linker,
                        linkerTel: item.linkerTel,
                        address:item.address,
                    }
                })
            })
        },
        //网点版图
        getNodeAddressInfo(){
            this.$api.NodeAddressInfo().then(res=>{
                res.data.data.map((item,i)=>{
                    this.nodeData[i] = {
                        name: item.name,
                        value: [item.gpsX, item.gpsY],
                        linker: item.linker,
                        linkerTel: item.linkerTel,
                        address:item.address,
                    }
                })
            })
        },
        //跳转异常页面
        toAbnomal(){
            this.$router.push('/AbnormalBigScreen')
        },
    },
    mounted(){
        this.getProductionInfo();
        this.getCollectionInfo();
        this.getSaleInfo();
        this.getServiceInfo();
        this.getAttentionDeviceInfo();
        this.getCustomerAddressInfo();
        this.getNodeAddressInfo();
        this.getDeviceAddressInfo();
        this.getAbnormalInfo();
    },
    beforeDestroy(){
        clearInterval(this.timer);
        window.removeEventListener('keydown',()=>{});
    }
}
</script>

<style lang="scss" scoped>
.conrainer{
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    background: url('../assets/images/bigScreen_back.webp') no-repeat center center;
    background-size: 100% 100%;
    display: flex;
    flex-direction: column;
}
.iconfont{
    font-family:"iconfont" !important;
    font-size: 32px;
    font-style: normal;
    color: #EDB941;
}
@keyframes mycircle
{
    0%{transform: scale(1.0);}
    50%{transform: scale(1.04);}
    100%{transform: scale(1.0);}
}
main{
    flex: 1;
    display: flex;
    color: #fff;
    position: relative;
    .center-tab{
        position: absolute;
        z-index: 1;
        color: #fff;
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-weight: bold;
        width: 15%;
        height: 4%;
        top: 0;
        bottom: 88%;
        left: 0;
        right: 0;
        margin: auto;
        font-size: 17px;
        cursor: pointer;
        p{
            height: 50%;
            width: 1px;
            border: 1px solid #fff;
        }
        .search{
            position: absolute;
            top: 2.8125rem;
            height: 110%;
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: space-between;
        }
        input{
            background: none;
            flex: 1;
            height: 95%;
            color: #fff;
            border: 1px solid #bbb;
            border-radius: 5px;
            padding-left: 10px;
        }
        button{
            background: #EDB941;
            color: #fff;
            height: 85%;
            width: 20%;
            border-radius: 5px;
            line-height: 0;
            cursor: pointer;
        }
        button:active{background: rgba($color: #EDB941, $alpha: 0.9);}
    }
    .tabcolor{
        color: #EDB941;
    }
    .main-left{
        width: 24.6%;
        padding-left: 1.25rem;
        padding-top: 0.55rem;
        position: relative;
        .clicktitle{
            width: 20%;
            white-space: nowrap;
            display: flex;
            align-items: center;
            justify-content: space-around;
            color: #EDB941;
            font-weight: bold;
            font-size: 1.55rem;
            cursor: pointer;
            span{
                border-bottom: 1px solid #EDB941;
            }
        }
    }
    .main-center{
        flex: 1;
        position: relative;
    }
    .main-right{
        width: 24.6%;
        padding-right: 1.25rem;
        padding-top: 0.55rem;
        position: relative;
        .clicktitle{
            width: 20%;
            white-space: nowrap;
            display: flex;
            align-items: center;
            justify-content: space-around;
            color: #EDB941;
            font-weight: bold;
            font-size: 1.55rem;
            cursor: pointer;
            span{
                border-bottom: 1px solid #EDB941;
            }
        }
    }
}
.main-left-ul{
    display: flex;
    flex-wrap: wrap;
    width: 74%;
    height: 13%;
    margin-top: 1rem;
    color: #fff;
    font-size: 1.125rem;
    font-weight: bold;
    li{
        width: 39%;
        height: 56%;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: center;
        &:nth-child(1),&:nth-child(4){
            width: 20%;
        }
        &:nth-child(2){
            justify-content: flex-start;
            padding-left: 0.5rem;
        }
        &:nth-child(5){
            display: block;
            padding-left: 0.5rem;
        }
        &:nth-child(1),&:nth-child(2),&:nth-child(3){
            height: 44%;
        }
        &:nth-child(2),&:nth-child(3){
            flex-direction: row;
        }
        &:nth-last-child(1),&:nth-last-child(2){
            font-weight: bold;
            font-size: 2.5rem;
            align-items: center;
        }
    }
}
.left-pei{
    margin-top: 1.25rem;
    height: 16%;
    display: flex;
    width: 73%;
    .left-pei0{
        flex: 1;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: center;
        font-size: 1.125rem;
        font-weight: bold;
    }
    .left-pei1,.left-pei2{
        width: 43.5%;
    }
}
.left-circle{
    height: 9.0625rem;
    width: 74%;
    font-weight: bold;
    text-align: center;
    padding-top: 1%;
    .left-circle0{
        background: rgba($color: #7194F3, $alpha: 0.5);
        width: 6.625rem;
        height: 6.625rem;
        border-radius: 50%;
        position: relative;
        margin: 0 auto;
        font-size: 1.4rem;
        line-height: 4rem;
    }
    .left-circle1,.left-circle2{
        background: rgba($color: #EDB941, $alpha: 0.4);
        width: 5.3125rem;
        height: 5.3125rem;
        border-radius: 50%;
        position: absolute;
        top: 45%;
        left: -35%;
        font-size: 0.75rem;
        white-space: nowrap;
        padding-top: 20%;
        line-height: 1.8rem;
        p{
            font-size: 1.5rem !important;
        }
    }
    .left-circle2{
        left: 55%;
    }
}
.charttitle{
    font-weight: bold;
    letter-spacing: 2px;
    position: absolute;
    bottom: 30.5%;
}
.left-chart-line{
    height: 30%;
    width: 96%;
    position: absolute;
    bottom: 0;
}
.right-sixcircle{
    width: 100%;
    height: 30%;
    font-weight: bold;
    .right-sixcircle0{
        animation: mycircle 5s linear infinite;
        width: 7rem;
        height: 7rem;
        background: rgba($color: #7194F3, $alpha: 0.5);
        border-radius: 50%;
        position: relative;
        display: flex;
        justify-content: center;
        text-align: center;
        padding-top: 5%;
        margin-left: 25%;
        margin-top: -5%;
        font-size: 1.3rem;
        .right-sixcircle1,.right-sixcircle2,.right-sixcircle3,.right-sixcircle4,.right-sixcircle5{
            position: absolute;
            top: 45%;
            left: -35%;
            background: rgba($color: #EDB941, $alpha: 0.4);
            border-radius: 50%;
            width: 5.5625rem;
            height: 5.5625rem;
            padding-top: 15%;
            font-size: 0.75rem;
            line-height: 1.8rem;
            white-space: nowrap;
            p{
                font-size: 1.5rem !important;
            }
        }
        .right-sixcircle2{
            left: 55%;
        }
        .right-sixcircle3{
            top: 55%;
            left: 125%;
        }
        .right-sixcircle4{
            top: 55%;
            left: 218%;
        }
        .right-sixcircle5{
            left: 160%;
            top: 94%;
            font-size: 1.3rem;
            padding-top: 50%;
        }
        .right-sixcircle5{
            width: 7rem;
            height: 7rem;
            background: rgba($color: #7194F3, $alpha: 0.5);
            border-radius: 50%;
        }
    }
}
.chaoqi{
    height: 15%;
    margin-top: 2%;
    display: flex;
    margin-left: 10%;
    .chaoqi1,.chaoqi2{
        width: 44%;
    }
    .chaoqi3{
        flex: 1;
        font-weight: bold;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        font-size: 1.125rem;
    }
}
.right-fuwu{
    display: flex;
    height: 11%;
    padding-left: 12%;
    .right-fuwu-item{
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-around;
        font-weight: bold;
        font-size: 16px;
        flex: 1;
        p{
            font-size: 25px;
            font-weight: bold;
        }
    }
}
.baoxiu{
    font-weight: bold;
    margin-top: 0.625rem;
    letter-spacing: 2px;
    position: absolute;
    bottom: 30.5%;
}
.baoxiuline{
    height: 30%;
    width: 96%;
    position: absolute;
    bottom: 0;
}
footer{
    height: 18.5%;
    color: #fff;
    display: flex;
    .ft-title{
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        font-size: 1.125rem;
        font-weight: bold;
        img{
            margin-bottom: 5px;
        }
    }
    .ft-left{
        display: flex;
        align-items: center;
        height: 100%;
        width: 24.6%;
        padding-left: 0.9rem;
        .yichang1,.yichang2{
            width: 50%;
            height: 95%;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            font-weight: bold;
            p{
                margin-top: 10px;
                font-size: 1.5rem;
            }
        }
        .yichang1{
            margin: 0 2rem;
        }
    }
    .ft-right{
        width: 75.4%;
        height: 100%;
        display: flex;
        align-items: center;
    }
    .swiper-father {
        width: 95%;
        height: 100%;
        position: relative;
        --swiper-navigation-color: #fff; /*按钮颜色 */
        --swiper-navigation-size: 25px; /*按钮大小 */
    }
    .swiper-container {
        width: 95%;
        height: 100%;
    }
    .swiper-wrapper {
        display: flex;
        align-items: center;
    }
    .swiper-slide {
        background: url('../assets/images/bigScreen_border.webp') no-repeat center center;
        background-size: 100% 100%;
        height: 100%;
        font-size: 0.9rem;
        display: flex;
        flex-direction: column;
        padding: 1.375rem 1.875rem;
        box-sizing: border-box;
    }
    .swiper-button-prev,
    .swiper-button-next {
        outline: none;
    }
    .swiper-top{
        height: 25%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        img{
            width: 1.875rem;
            height: 1.875rem;
        }
       
    }
    .swiper-item{
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        p{
            font-size: 0.79rem;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
        }
        .click-span{
            text-decoration: underline;
            color: #EDB941;
            cursor: pointer;
        }
    }
}
</style>